import '@fontsource-variable/dm-sans'
import '@fontsource-variable/manrope'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ProveedorAuth } from '@eg/compartido'
import { ProveedorAvisos, ProveedorMovimiento } from '@eg/efectos'
import { App } from './app/App'
import { iniciarIdioma, ProveedorIdioma } from './content/idioma'
import { ProveedorCarrito } from './lib/carrito'
import { supabase } from './lib/supabase'
import './index.css'

// Los textos se fijan antes de dibujar: en la demostración puede abrir en inglés.
iniciarIdioma()

const consultas = new QueryClient({ defaultOptions: { queries: { staleTime: 60_000, retry: 1 } } })

createRoot(document.getElementById('raiz')!).render(
  <StrictMode>
    <QueryClientProvider client={consultas}>
      <ProveedorAuth cliente={supabase}>
        <ProveedorMovimiento>
          <ProveedorAvisos>
            <ProveedorCarrito>
              <BrowserRouter>
                <ProveedorIdioma>
                  <App />
                </ProveedorIdioma>
              </BrowserRouter>
            </ProveedorCarrito>
          </ProveedorAvisos>
        </ProveedorMovimiento>
      </ProveedorAuth>
    </QueryClientProvider>
  </StrictMode>,
)
